export const ArGameNames: string[] = ['AR Pyramid Puzzle'];

export const ArMiniGames = {
  'Where in the World?': {
    type: 'where-in-the-world',
    defaultTimer: '180',
    defaultScore: 500
  },
  'Where in the World? - Easy': {
    type: 'where-in-the-world',
    defaultTimer: '180',
    defaultScore: 500
  },
  'Where in the World? - Hard': {
    type: 'where-in-the-world',
    defaultTimer: '180',
    defaultScore: 500
  },
  'Summer Suitcase': {
    type: 'summer-suitcase',
    defaultTimer: '180',
    defaultScore: 300
  },
  'Sound Waves': { type: 'sound-waves', defaultTimer: '0', defaultScore: 500 },
  'The Portal': { type: 'the-portal', defaultTimer: '0', defaultScore: 500 },
  'Meerkats Moves': {
    type: 'meerkat-moves',
    defaultTimer: '0',
    defaultScore: 0
  },
  'Game Cube': { type: 'game-cube', defaultTimer: '180', defaultScore: 300 }
};

export const getOtherBaseUrl = () => {
  const currentHost = window.location.hostname;

  let environment = 'production';

  if (currentHost.includes('development')) {
    environment = 'development';
  }

  if (currentHost.includes('staging')) {
    environment = 'staging';
  }

  switch (environment) {
    case 'development':
    case 'staging':
      return 'https://envau01.catalystglobal.games';
    case 'production':
      return 'https://envau01.development.catalystglobal.games';
  }
};
